import { Route } from 'src/routes/Route'

export const AudereRoute = Route({
  path: '/audere',
  hideTopBar: true,
})
export type AudereRoute = Route<typeof AudereRoute>
